import React from 'react';
import {
  showToolTip,
} from './utils';
import TimelinesChart from 'timelines-chart';
import fromKapsule from 'react-kapsule';
import electionData from './output-data.js';
import './App.css'

function App() {
  const myKapsule = TimelinesChart;
  const MyKapsuleComponent = fromKapsule(myKapsule);


  return (
    <div className="App">

        <div className="App-header">
          <div>
          When do Local Elections Align with State + National Elections?
          </div>
          <div className="App-sub-header">
          The Data Team at Cicero
          </div>
          <div className="App-sub-container">
            <a href='https://medium.com/cicero-data/' style={{'text-decoration': 'none', 'rightMargin':'20px'}} >
              <div className="App-sub-item App-link">
                Return to the Cicero Blog
              </div>
            </a>
            <a href='https://www.cicerodata.com/' style={{'text-decoration': 'none'}}>
              <div className="App-sub-item App-link">
                Visit Cicerodata.com
              </div>
            </a>
          </div>
        </div>     
        <MyKapsuleComponent
          data={electionData}
          maxHeight={10000}
          rightMargin={300}
          leftMargin={130}
          segmentTooltipContent={showToolTip}
          zQualitative={true}
          />   
    </div>
  );
}

export default App;
